'use client';

import { EnvelopeIcon } from '@heroicons/react/24/outline';
import Icon from '@/components/ui/AppIcon';

interface ContactSectionProps {
  currentLanguage: string;
}

const ContactSection = ({ currentLanguage }: ContactSectionProps) => {
  // Use only English content
  const content = {
    en: {
      heading: 'Contact Us',
      emailLabel: 'Email',
      linkedinButton: 'Connect on LinkedIn'
    },
  };

  const lang = content.en; // Always use English

  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-green-50 to-blue-50">
      <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6 md:mb-8">
            {lang.heading}
          </h2>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            {/* Email Button */}
            <a
              href="mailto:nupurbanker@gmail.com"
              className="flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <EnvelopeIcon className="w-6 h-6" />
              <span>{lang.emailLabel}: nupurbanker@gmail.com</span>
            </a>

            {/* LinkedIn Button */}
            <a
              href="https://www.linkedin.com/in/dr-nupur-mishra-b8a89a1a/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <Icon
                src="/assets/images/linkedin-icon.svg"
                alt="LinkedIn"
                className="w-6 h-6"
              />
              <span>{lang.linkedinButton}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;